<template>

    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
        >
        </FilterPanel>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.scheme_name`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.scheme_name">
                                    {{item.scheme_name}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.document_theme`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.document_theme">
                                    {{item.document_theme}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.starttime`]="{ item }">
                        {{$moment(item.starttime).format('DD.MM.YYYY HH:mm')}}
                    </template>

                    <template v-slot:[`item.state`]="{ item }">
                        {{$t(workflowStates[item.state])}}
                    </template>

                    <template v-slot:[`item.initiator_name`]="{ item }">
                        <v-workplace-chip v-if="item.initiator_workplace_id" :id="item.initiator_workplace_id" :name="item.initiator_name" />
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">

                        <span
                            v-if="[6].includes(item.state)"
                            @click="onWorkflowClick(item, 'Resume')"
                            class="tbl-action-button"
                            v-tooltip.left-center="$t('Возобновить')"
                        >
                            <i style="color: #388E3C;" class="fas fa-play"></i>
                        </span>

                        <span
                            v-if="[1, 2].includes(item.state)"
                            @click="onWorkflowClick(item, 'Suspend')"
                            class="tbl-action-button"
                            v-tooltip.left-center="$t('Приостановить')"
                        >
                            <i style="color: #FBC02D;" class="fas fa-pause"></i>
                        </span>

                        <span
                            v-if="[1, 2, 6].includes(item.state)"
                            @click="onWorkflowClick(item, 'Cancel')"
                            class="tbl-action-button"
                            v-tooltip.left-center="$t('Отменить')"
                        >
                            <i style="color: #D32F2F;" class="fas fa-stop"></i>
                        </span>

                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>

    </div>

</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    name: "StartedWorkflows",
    columnIndex:  {
        'document_number': 14,
        'document_theme': 13,
        'scheme_name': 8,
        'starttime': 10,
        'state': 5,
        'initiator_name': 12
    },
    components: {
        Toolbar,
        SearchPanel,
        FilterPanel
    },
    computed : {
        ...mapGetters('global/configuration/startedWorkflows', { workflowStates: 'getWorkflowStates' }),
        collection() {
            return 'StartedWorkflows';
        },
        headers() {
            return [
                { text: this.$t("Номер"), value: 'document_number', width: '150px' },
                { text: this.$t("Краткое_содержание"), value: 'document_theme' },
                { text: this.$t("Схема"), value: 'scheme_name', width: '250px' },
                { text: this.$t("Запущено"), value: 'starttime', width: '160px' },
                { text: this.$t("Состояние"), value: 'state', width: '160px', sortable: false },
                { text: this.$t("Запустил"), value: 'initiator_name', width: '110px', sortable: false },
                { text: '', value: 'actions', width: '60px', sortable: false }
            ];
        },
        filterDataSource() {
            return { 
                Filter: { 
                    Title: "Категория",
                    Items: [
                        { Name: "В_работе", Value: "0", Count: -1, HasItems: false, Requires: [], Items: null },
                        { Name: "Приостановленные", Value: "1", Count: -1, HasItems: false, Requires: [], Items: null }
                    ]
                }
            };
        },
        status: {
            get: function() {
                return this.$store.getters['global/configuration/startedWorkflows/getStatus'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/finishedWorkflows/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/startedWorkflows/SET_STATUS', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['global/configuration/startedWorkflows/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/configuration/startedWorkflows/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/startedWorkflows/SET_TABLE_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters['global/configuration/startedWorkflows/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/startedWorkflows/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                Status: this.status,
                SearchStr: this.search
            }
        }
    },
    data() {
        return {
            loading: true,
            total: 0,
            entities: [],
            dataSource: null,
            paginationPageCount: 0,
        }
    },    
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(event, btn) {
            this[btn.Action](btn);
        },
        async getData(isRefresh = false) {
            let filterJson = this.getSerializedFilter();
            let newFilterObj = JSON.parse(filterJson);

            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newFilterObj))
                return;

            this.setOverlayVisible({ visible: true });
            this.prevTableFilterObject = newFilterObj;
            this.total = 0;
            this.loading = true;

            let response = await httpAPI({
                url: `api/document-templates/list?collection=${this.collection}&filter=${filterJson}`,
                method: 'GET',
                headers: { 'isCommon': false },
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
            this.setOverlayVisible({ visible: false });
        },
        getSerializedFilter() {
            let { sortBy, sortDesc, page, itemsPerPage, Status, SearchStr } = this.filter;

            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "starttime" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn];

            let enterpriseId = this.$store.getters['global/auth/getUserInfo']?.EnterpriseId ?? null;
            let states = [];

            switch (Status) {
                case "1":
                    states = [ 6 ];
                    break;

                default:
                    states = [ 1, 2 ];
                    break;
            }

            return JSON.stringify({ SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, States: states, EnterpriseId: enterpriseId });
        },
        async Refresh() {
            await this.getData(true);
        },
        async onWorkflowClick(workflow, action) {

            let response = await httpAPI({
                url: `api/document-templates/workflow?action=${action}&stateId=${workflow.state_id}`,
                method: 'GET',
                headers: { 'isCommon': false },
            });
            
            if (!response) return;

            this.$notify.success(response.data.Payload?.Message);
            await this.Refresh();
        }
    },
    watch: {
        filter: {
            handler() {
                this.getData();
            },
            deep: true,
        },
    },
    async created() {
        this.setOverlayVisible({ visible: true });        
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить_форму", Type: null, Localize: true }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });
        this.setOverlayVisible({ visible: false });
    }
}
</script>
